import { render, staticRenderFns } from "./PositionSummary.vue?vue&type=template&id=22bf548c&scoped=true"
import script from "./PositionSummary.vue?vue&type=script&lang=js"
export * from "./PositionSummary.vue?vue&type=script&lang=js"
import style0 from "./PositionSummary.vue?vue&type=style&index=0&id=22bf548c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@7.0.0-bridge.0_@babel+core@7.26.7__cac_fzj6xqfhz2iur5pptcdfbzd24y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf548c",
  null
  
)

export default component.exports